// extracted by mini-css-extract-plugin
export default {"bannerContent":"BannnerContent_bannerContent__nJ7Lm"};